import React from 'react';
import { Input, Typography, Button } from 'antd';
import { CheckOutlined, CloseOutlined } from '@ant-design/icons';
import ColorSelector from '../ColorSelector';

export const GeneralContent = ({
  inputName,
  setATData,
  ATData,
  setInputName,
  color,
  setColor,
  editType,
  setCellNumber,
  cellNumber,
  purpose,
  t,
  selectedKeysInfo
}) => [
  {
    key: 0,
    content: (
      <>
        <Typography>{t('schema.toolbar.name')}:</Typography>
        <Input
          allowClear
          style={{
            width: 100
          }}
          defaultValue={inputName}
          onChange={(e) => {
            if (editType === 'AT') {
              setATData({ ...ATData, name: e.target.value });
            }
            setInputName(e.target.value);
          }}
        />
      </>
    )
  },
  ...((editType === 'DE' && purpose === 'create') ||
  (editType === 'TR' &&
    purpose === 'edit' &&
    selectedKeysInfo.node.type !== 'TR') ||
  (editType === 'DE' &&
    purpose === 'edit' &&
    selectedKeysInfo.node.type === 'DE')
    ? [
        {
          key: 1,
          content: (
            <>
              <Typography>{t('schema.toolbar.cell_number')}:</Typography>
              <Input
                allowClear
                style={{
                  width: 100
                }}
                defaultValue={cellNumber}
                onChange={(e) => {
                  setCellNumber(e.target.value);
                }}
              />
            </>
          )
        }
      ]
    : []),
  {
    key: 2,
    content: (
      <>
        <Typography>{t('schema.toolbar.color')}:</Typography>
        <ColorSelector color={color} setColor={setColor} />
      </>
    )
  }
];

export const ButtonsContent = ({
  checkWarningUpdate,
  setWarningColor,
  setWarningText,
  setwarningAT,
  setwarningAtData,
  setPurpose,
  t,
  isLoadingButton
}) => [
  {
    key: 9,
    content: (
      <div
        style={{
          display: 'inline-flex'
        }}
      >
        <Button
          loading={isLoadingButton}
          disabled={isLoadingButton}
          type="primary"
          onClick={() => checkWarningUpdate()}
        >
          <CheckOutlined /> {t(`buttons.validate`)}
        </Button>
        <Button
          type="link"
          onClick={() => {
            setWarningColor(false);
            setWarningText(false);
            setwarningAT(false);
            setwarningAtData(false);
            setPurpose('init');
          }}
        >
          <CloseOutlined /> {t(`buttons.cancel`)}
        </Button>
      </div>
    )
  }
];
